import templateUrl from "emun.filemanager/edit-file-prompt.htm";
import angular from "angular";
import ServiceBus from "servicestack/service-bus";
import modals from "webmodals/modals";
import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from "servicestack/basic.controller.properties";
import config from "emun.filemanager/file-manager.config";

class controller {
	constructor($scope, options) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.config = config;
		$ctrl.bus = new ServiceBus();
		$ctrl.title = "Edit File Information...";
		$ctrl.visibilityOptions = ["Public", "Private"];

		$ctrl.request = $ctrl.options.file;
		$ctrl.save = function () {
			$ctrl.bus.send("UpdateMedia.json", $ctrl.request).then(function (response) {
				$ctrl.$dismiss();
			});
		};
	}
}
export default {
	open(options) {
		return modals.open(
			Object.assign(
				{
					templateUrl,
					resolve: {
						options: () => options
					},
					bindToController: true,
					controller,
					controllerAs: "$ctrl",
					size: "lg"
				},
				(options || {}).modal
			)
		).result;
	}
};
